import styled from '@emotion/styled';

// Container

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
`;

// Content

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
`;
